export class LibObjetMessage {
  libelleCaffr!: string;
  libelleMobile!: string;
  selectionnable!: boolean;
  code!: string;
  statSid!: string;
  cleRnProduit!: string;
}

export class LibMotifReclamation {
  libelleCaffr!: string;
  libelleMobile!: string;
  selectionnable!: boolean;
  famille!: string;
  code!: string;
}

export class LibPrestation {
  libelleCaffr!: string;
  libelleMobile!: string;
  selectionnable!: boolean;
  code!: string;
}

